import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import localStorage from '../utils/localStorage';

const COMPANY_ID = process.env.REACT_APP_COMPANY_ID;

class AuthStore {

    // Properties

    @observable inProgress = false;
    @observable errors = undefined;
    @observable pushcallbackUrl = '';
    @observable hasRoomNumberInUrl = false;
    @observable hasLastNameInUrl = false;

    // Admin Properties

    @observable adminLoginLoading = false;

    @observable values = {
        companyId: COMPANY_ID,
        lastName: '',
        roomNumber: ''
    };

    // Transaction

    @action initGuestLogin() {
        this.removeGuestInformationInStorage();
    }

    @action guestLogin() {
        return ApiCaller.User.apiLoginAsGuest(this.values.companyId, this.values.roomNumber, this.values.lastName, this.pushcallbackUrl).then((guestLoginResponse) => {
            if (guestLoginResponse) {
                if (!guestLoginResponse.success) {
                    this.removeGuestInformationInStorage();
                    return guestLoginResponse;
                } else {
                    if (guestLoginResponse.result) {
                        this.setGuestInformationInStorage(guestLoginResponse);
                        return guestLoginResponse;
                    } else {
                        this.removeGuestInformationInStorage();
                        return guestLoginResponse;
                    }
                }
            } else {
                this.removeGuestInformationInStorage();
                return null;
            }
        })
    }

     @action onlyGuestNumberLogin() {
        return ApiCaller.User.apiLoginOnlyRoomNumber(this.values.companyId, this.values.roomNumber, this.values.lastName, this.pushcallbackUrl).then((guestLoginResponse) => {
            if (guestLoginResponse) {
                if (!guestLoginResponse.success) {
                    this.removeGuestInformationInStorage();
                    return guestLoginResponse;
                } else {
                    if (guestLoginResponse.result) {
                        this.setGuestInformationInStorage(guestLoginResponse);
                        return guestLoginResponse;
                    } else {
                        this.removeGuestInformationInStorage();
                        return guestLoginResponse;
                    }
                }
            } else {
                this.removeGuestInformationInStorage();
                return null;
            }
        })
    }

    @action adminLogin(loginName, password) {
        this.adminLoginLoading = true;
        return ApiCaller.User.AdminLogin(loginName, password).then((adminLoginResponse) => {
            this.adminLoginLoading = false;
            return adminLoginResponse;
        });
    }

    @action adminLoginToken(token) {
        this.adminLoginLoading = true;
        return ApiCaller.User.AdminLoginToken(token).then((adminLoginResponse) => {
            this.adminLoginLoading = false;
            return adminLoginResponse;
        });
    }

    @action guestLog() {
        const roomNo = window.localStorage.getItem('roomNo').replace(/['"]+/g, '');
        const fullName = window.localStorage.getItem('fullName').replace(/['"]+/g, '');

        return ApiCaller.GuestLoginLogs.create(roomNo, fullName);
    }

    // GET Properties

    @action getUserStoredEmailPassword() {
        return {
            email: window.localStorage.getItem('userEmail'),
            password: window.localStorage.getItem('userPassword')
        };
    }

    // SET Properties

    @action setLastname(value) {
        this.values.lastName = value;
    }

    @action setRoomNumber(value) {
        this.values.roomNumber = value;
    }

    @action setPushcallbackUrl(value) {
        this.pushcallbackUrl = value;
    }

    @action setHasRoomNumberInUrl(value) {
        this.hasRoomNumberInUrl = value;
    }

    @action setHasLastNameInUrl(value) {
        this.hasLastNameInUrl = value;
    }

    @action setGeneralConfiguration() {
        return ApiCaller.Configuration.apiGetConfigurations().then((configurationResponse) => {
            if (configurationResponse) {
                if (configurationResponse) {
                    if (configurationResponse.vat) {
                        window.localStorage.setItem('vat', configurationResponse.vat);
                    } else {
                        window.localStorage.setItem('vat', 0);
                    }

                    if (configurationResponse.serviceFee) {
                        window.localStorage.setItem('serviceFee', configurationResponse.serviceFee);
                    } else {
                        window.localStorage.setItem('serviceFee', 0);
                    }
                } else {
                    window.localStorage.setItem('vat', 0);
                    window.localStorage.setItem('serviceFee', 0);
                }
            }
        })
    }

    @action setGuestInformationInStorage(guestLoginResponse) {
        const { id, tenantId, roomName, reservationNumber, firstName, lastName, checkInDateLocal, checkOutDateLocal, title, fullName } = guestLoginResponse.result;

        localStorage.Save('customerId', id);
        localStorage.Save('companyId', tenantId);
        localStorage.Save('roomNo', roomName);
        localStorage.Save('reservationNumber', reservationNumber);
        localStorage.Save('firstName', firstName);
        localStorage.Save('lastName', lastName);
        localStorage.Save('checkinTime', checkInDateLocal);
        localStorage.Save('checkoutTime', checkOutDateLocal);
        localStorage.Save('title', title);
        localStorage.Save('fullName', fullName);
    }

    // DELETE Properties

    @action removeGuestInformationInStorage() {
        localStorage.Remove('customerId');
        localStorage.Remove('companyId');
        localStorage.Remove('reservationNumber');
        localStorage.Remove('firstName');
        localStorage.Remove('fullName');
        localStorage.Remove('checkinTime');
        localStorage.Remove('checkoutTime');
        localStorage.Remove('title');
        localStorage.Remove('vat');
        localStorage.Remove('serviceFee');
        localStorage.Remove('totalOrder');
        this.values.lastName = '';
        this.values.roomNumber = '';
        this.pushcallbackUrl = '';
    }

    @action removeAdminInfo() {
        localStorage.Remove('adminLoginName');
        localStorage.Remove('adminLoginPassword');
        localStorage.Remove('adminLoginRole');
        localStorage.Remove('adminLoginToken');
    }
}

export default new AuthStore()